function getParameterByName(name, url = window.location.href) {
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return "";
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}
const courseType = getParameterByName("type");
const sgid = getParameterByName("sgid");
const area = getParameterByName("area");
const staffBookingMeta = document.querySelector('meta[name="schedule-staff-booking"]');
const staffBooking = Boolean(staffBookingMeta && staffBookingMeta.content === "true");
const isGym = Boolean(courseType === 'gym')
const isFunction = Boolean(courseType === "function");

const obj = {
  courseType: courseType,
  isGym: isGym,
  isFunction: isFunction,
  sgid: sgid,
  area: area,
  staffBooking: staffBooking
};
export default obj;
